import moment from 'moment-timezone';

export const CLIENT_TIMEZONE = 'America/New_York';
export const DEFAULT_TIMEZONE = 'America/Denver';

/**
 * Returns the timezone string based on the user's role.
 * @param {string} role - The user's role (e.g., 'main_account', 'client_sub_user', 'admin').
 * @returns {string} - Timezone string (e.g., 'America/New_York' or 'America/Denver').
 */
export const getTimezoneByRole = (role) => {
    if (role === 'main_account' || role === 'client_sub_user') {
        return CLIENT_TIMEZONE;
    }
    return DEFAULT_TIMEZONE;
};

/**
 * Formats a UTC date/time string to the target timezone.
 * @param {string} dateTimeString - The UTC date/time string.
 * @param {string} role - The user's role.
 * @param {string} format - The desired output format.
 * @returns {string} - Formatted date/time string.
 */
export const formatTimeByRole = (dateTimeString, role, format = 'YYYY-MM-DD HH:mm') => {
    if (!dateTimeString) return 'N/A';
    const tz = getTimezoneByRole(role);

    // Datetimes are stored as Denver local time — parse in that context, then convert to display tz
    const m = dateTimeString.includes('-') && dateTimeString.includes(':') && dateTimeString.indexOf('-') < 3
        ? moment.tz(dateTimeString, 'DD-MM-YYYY HH:mm', DEFAULT_TIMEZONE)
        : moment.tz(dateTimeString, DEFAULT_TIMEZONE);

    return m.tz(tz).format(format);
};
